export default __webpack_public_path__ + "static/media/logo_512.261bdb82.png";